import Icon from '@components/icons/Icon';
import { IconButton, theme } from 'aimo-ui';
import { ButtonTypes } from 'aimo-ui/lib/typescript/src/components/Button/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { testIdentifiers } from 'utils/testIdentifiers';

type RemoveButtonProps = {
  onPress?: () => void;
  testID?: string;
  buttonType?: ButtonTypes;
  disabled: boolean;
};

const BinIcon = () => (
  <Icon
    name="Bin"
    size="m"
    strokeColor={theme.colors.white}
    color={theme.colors.white}
  />
);

const RemoveButton = ({
  onPress,
  testID,
  buttonType = 'tertiary',
  disabled,
}: RemoveButtonProps) => {
  const { t } = useTranslation();
  return (
    <IconButton
      fullWidth={false}
      buttonType={buttonType}
      onPress={onPress}
      {...testIdentifiers(testID as string)}
      iconComponent={BinIcon}
      disabled={disabled}
      accessibilityLabel={t('button.remove')}
    />
  );
};

export default RemoveButton;
